<div class="min-h-[100vh] flex flex-col">
    @if (!hideLayout) {
        <app-header [isAuthLayout]="true"></app-header>
    }
    <div class="flex-1 flex flex-col h-full">
        <router-outlet></router-outlet>
    </div>
    @if (!hideLayout) {
        <app-footer></app-footer>
    }
</div>
